import classNames from '../_util/classNames';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import getEmptyImg from './empty';
import SimpleEmptyImg from './simple';
import { filterEmpty } from '../_util/props-util';
import PropTypes from '../_util/vue-types';
import { withInstall } from '../_util/type';
import useConfigInject from '../_util/hooks/useConfigInject';
import Button from '../button';
const simpleEmptyImg = <SimpleEmptyImg />;
const Empty = (props, { slots = {}, attrs, emit }) => {
    const { direction, prefixCls: prefixClsRef, configProvider } = useConfigInject('empty', props);
    const prefixCls = prefixClsRef.value;
    const { image = getEmptyImg(), description = slots.description?.() || undefined, imageStyle, class: className = '', mode, type, noImage, scene = 'default', ...restProps } = { ...props, ...attrs };
    const theme = props.mode ?? configProvider.mode;
    const refresh = () => {
        emit('refresh');
    };
    return (<LocaleReceiver componentName="Empty" children={(locale) => {
            const LOCALE_DESC = {
                default: locale.description,
                permi: locale.permiDesc,
                network: locale.networkDesc,
                found: locale.foundDesc,
                account: locale.accountDesc,
                message: locale.messageDesc,
                system: locale.systemDesc,
                search: locale.searchDesc,
            };
            const desc = LOCALE_DESC[scene] || locale.description;
            const des = typeof description !== 'undefined' ? description : desc;
            const alt = typeof des === 'string' ? des : 'empty';
            let imageNode = null;
            if (typeof image === 'string') {
                imageNode = <img alt={alt} src={image}/>;
            }
            else {
                imageNode = theme ? getEmptyImg({ mode: theme, scene }) : image;
            }
            const isImage = !noImage && type !== 'text';
            let desContent;
            if (scene === 'network') {
                if (!['module', 'text'].includes(type)) {
                    desContent = <p class={`${prefixCls}-description`}>{des}</p>;
                }
                else {
                    desContent = (<p class={`${prefixCls}-description`}>
                {locale.networkModuleDesc}
                <span class={`${prefixCls}-refresh-btn`} onClick={refresh}>
                  {locale.btn.network}
                </span>
              </p>);
                }
            }
            else {
                desContent = desc && <p class={`${prefixCls}-description`}>{des}</p>;
            }
            let footerContent;
            if (scene === 'network') {
                footerContent = !['module', 'text'].includes(type) && (<div class={`${prefixCls}-footer`}>
              <Button type="primary" onClick={refresh}>
                {locale.btn?.network}
              </Button>
            </div>);
            }
            else {
                footerContent = slots.default && (<div class={`${prefixCls}-footer`}>{filterEmpty(slots.default())}</div>);
            }
            return (<div class={classNames(prefixCls, className, {
                    [`${prefixCls}-normal`]: image === simpleEmptyImg,
                    [`${prefixCls}-rtl`]: direction.value === 'rtl',
                    [`${prefixCls}-module`]: type === 'module',
                    [`${prefixCls}-text`]: type === 'text',
                })} {...restProps}>
            {isImage && (<div class={`${prefixCls}-image`} style={imageStyle}>
                {imageNode}
              </div>)}
            {desContent}

            {footerContent}
          </div>);
        }}/>);
};
Empty.displayName = 'WdEmpty';
Empty.inheritAttrs = false;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
Empty.props = {
    prefixCls: String,
    image: PropTypes.any,
    description: PropTypes.any,
    imageStyle: { type: Object, default: undefined },
    scene: { type: String, default: 'default' },
    mode: { type: String, default: undefined },
    onRefresh: { type: Function, default: undefined },
};
export default withInstall(Empty);
